import fuze from './fuze'

export class CurrentEnv {
  isDevelopment() {
    return 'development' === this.flag
  }

  isProduction() {
    return 'production' === this.flag
  }

  constructor(flag) {
    fuze(this, { flag })
  }
}

export default new CurrentEnv(process.env.NODE_ENV)
